import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c(VContainer,[_c('BasePageTitle',{attrs:{"title":_vm.compTitle,"subtitle":_vm.displayRandomSubtitleGreeting,"subtitle-on-top":""}}),_c(VRow,[_c(VCol,{class:_vm.isMobileViewPort ? 'px-0 mx-0' : ''},[_c('TheDashboardNavigation')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }